module.exports = __webpack_public_path__ + "img/BM.3caa3c35.png";